import React from "react";
import MainCard from "./MainCard";

function BorderTopCard({ className,color, children, ...props }: CardPropsType) {
  return (
    <MainCard
      className={`lg:mt-[-34px] lg:!px-4 lg:!py-4 !py-[11px] lg:!pb-8  !px-[11px] flex flex-col gap-5 rounded-t-[10px] rounded-b-[20px] border-t-[10px]  border-secondary ${className}`}
      {...props}
      style={{borderColor:color}}
    >
      {children}
    </MainCard>
  );
}

export default BorderTopCard;
export type CardPropsType = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;
